import { Action, createReducer, on } from "@ngrx/store";
import { TaxViewColumn1ViewModelActions } from "../actions";
import {
  initialState,
  Column1ViewModelState,
} from "../states/column_1_view_model.states";
export const TaxViewColumn1ViewModelReducer = createReducer(
  initialState,
  on(TaxViewColumn1ViewModelActions.setGenericDocTaxListing_State, (state, action) => ({
    ...state, genericDocTaxListingState: action.genericDocTaxListingState
  })),
);
export function reducer(
  state: Column1ViewModelState | undefined,
  action: Action
) {
  return TaxViewColumn1ViewModelReducer(state, action);
}